import { LauncherElementType } from '../../info/launcherElementInfo';
import { createStore } from '../createStore';

export interface MouseData {
  pos: { x: number; y: number };
  movement: { x: number; y: number };
  isDown: boolean;
  button: number;

  target: HTMLElement | null;
  hoveredUIElement: string | null;
  
  isDragging: boolean;
  draggingStartPos?: { x: number; y: number } | null;
  draggingDiff?: { x: number; y: number } | null;

  hoveredLauncherElementType: LauncherElementType | 'handle' | 'scene' | null;
  hoveredLauncherElementID: string | null;

  doubleClick: MouseEvent | null;
}

export const mouseDefault: MouseData = {
  pos: { x: 0, y: 0 },
  movement: { x: 0, y: 0 },
  isDown: false,
  button: 0,
  
  target: null,
  hoveredUIElement: null,

  isDragging: false,
  draggingStartPos: null,
  draggingDiff: null,

  hoveredLauncherElementType: null,
  hoveredLauncherElementID: null,

  doubleClick: null,
};

export const [MouseStoreProvider, useMouseStore] = createStore<MouseData>(mouseDefault);
